import { createGenericSlice } from '../../../../../utils/slices'
import { APPLICATION_TYPES, MEMBER_TYPES, SSTHT_WALL } from '../../../common/constants'

export const wallSlice = createGenericSlice({
  name: 'wall',
  initialState: {
    applicationType: APPLICATION_TYPES.PERPENDICULAR_TO_WALL,
    memberType: MEMBER_TYPES.STUD,
    type: SSTHT_WALL.STUD_DF,
    topPlateThickness: 1.5,
    topPlateWidth: 3.5,
    topPlatePlies: 2,
    studPlies: 1,
    studThickness: 1.5,
    studAlignmentOffset: 0,
    studAlignment: true,
    isStudMember: true,
    // Data for GA Event
    lumberSpecies: 'DF (Douglas Fir)',
  },
})

export const wallActions = wallSlice.actions
